(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["tabbed-panel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tabbed-panel-component')) {
    class TabbedPanelComponent extends HTMLElement {
      connectedCallback() {
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.init();
        this.mobileQuery.addEventListener('change', () => this.applyLayout());
      }

      disconnectedCallback() {
        this.dataset.initialized = 'false';
      }

      init() {
        this.tabList = this.querySelector('[data-tab-list]');
        this.panelsContainer = this.querySelector('[data-tab-panels]');
        if (!this.tabList || !this.panelsContainer) return;

        this.panels = Array.from(this.panelsContainer.querySelectorAll('[data-tab-panel]')).filter(
          (panel) => (panel.dataset.tabTitle || '').trim().length > 0
        );
        if (!this.panels.length) return;

        this.tabs = [];
        this.tabList.innerHTML = '';

        this.panels.forEach((panel, index) => {
          const panelSurface = panel.querySelector('.tabbed-panel-tab__panel');
          const panelId = panelSurface?.id || `TabPanel-${this.id}-${index}`;
          if (panelSurface && !panelSurface.id) panelSurface.id = panelId;

          const accordionTrigger = panel.querySelector('[data-accordion-trigger]');
          if (accordionTrigger && !accordionTrigger.dataset.bound) {
            accordionTrigger.dataset.bound = 'true';
            accordionTrigger.addEventListener('click', () => this.toggleAccordion(index));
          }

          const title = panel.dataset.tabTitle.trim();
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'tabbed-panel__tab';
          button.role = 'tab';
          button.id = `TabDesktopTrigger-${panelId}`;
          button.setAttribute('aria-controls', panelId);
          button.setAttribute('aria-selected', 'false');
          button.tabIndex = -1;
          button.textContent = title;

          button.addEventListener('click', () => this.activateTab(index));
          button.addEventListener('keydown', (event) => this.handleKeydown(event, index));

          this.tabList.appendChild(button);
          this.tabs.push(button);
        });

        this.applyLayout();
        this.dataset.initialized = 'true';
      }

      isMobileAccordion() {
        return this.mobileQuery.matches && this.dataset.mobileLayout === 'accordion';
      }

      applyLayout() {
        if (this.isMobileAccordion()) {
          this.classList.add('tabbed-panel--mobile-accordion');
          this.applyAccordionLayout();
          return;
        }

        this.classList.remove('tabbed-panel--mobile-accordion');
        this.applyTabLayout();
      }

      applyTabLayout() {
        const defaultIndex = this.panels.findIndex((panel) => panel.dataset.tabDefault === 'true');
        const activeIndex = this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
        this.activateTab(activeIndex >= 0 ? activeIndex : (defaultIndex >= 0 ? defaultIndex : 0));
      }

      applyAccordionLayout() {
        this.tabs.forEach((tab) => {
          tab.setAttribute('aria-selected', 'false');
          tab.tabIndex = -1;
        });

        this.panels.forEach((panel) => {
          panel.classList.add('is-active');
          panel.hidden = false;
        });

        const defaultIndex = this.panels.findIndex((panel) => panel.dataset.tabDefault === 'true');
        const hasOpenPanel = this.panels.some((panel) => panel.dataset.accordionOpen === 'true');

        this.panels.forEach((panel, index) => {
          const shouldOpen = hasOpenPanel
            ? panel.dataset.accordionOpen === 'true'
            : index === (defaultIndex >= 0 ? defaultIndex : 0);
          this.setAccordionState(index, shouldOpen, false);
        });
      }

      animatePanel(panelSurface) {
        if (!panelSurface || this.dataset.tabAnimation === 'false') return;
        panelSurface.classList.remove('tabbed-panel-tab__panel--animate');
        void panelSurface.offsetWidth;
        panelSurface.classList.add('tabbed-panel-tab__panel--animate');
      }

      activateTab(index) {
        this.panels.forEach((panel, panelIndex) => {
          const panelSurface = panel.querySelector('.tabbed-panel-tab__panel');
          const isActive = panelIndex === index;

          panel.classList.toggle('is-active', isActive);
          panel.hidden = false;

          if (panelSurface) {
            panelSurface.hidden = !isActive;
            if (isActive) this.animatePanel(panelSurface);
          }

          this.tabs[panelIndex].setAttribute('aria-selected', isActive ? 'true' : 'false');
          this.tabs[panelIndex].tabIndex = isActive ? 0 : -1;
        });
      }

      toggleAccordion(index) {
        const panel = this.panels[index];
        const isOpen = panel.dataset.accordionOpen === 'true';
        const allowMultiple = this.dataset.mobileAccordionMultiple === 'true';

        if (!allowMultiple && !isOpen) {
          this.panels.forEach((_, panelIndex) => {
            this.setAccordionState(panelIndex, panelIndex === index, false);
          });
          return;
        }

        this.setAccordionState(index, !isOpen, true);
      }

      setAccordionState(index, isOpen, focusTrigger) {
        const panel = this.panels[index];
        const panelSurface = panel.querySelector('.tabbed-panel-tab__panel');
        const accordionTrigger = panel.querySelector('[data-accordion-trigger]');

        panel.dataset.accordionOpen = isOpen ? 'true' : 'false';
        if (panelSurface) {
          panelSurface.hidden = !isOpen;
          if (isOpen) this.animatePanel(panelSurface);
        }
        if (accordionTrigger) {
          accordionTrigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
          if (focusTrigger && isOpen) accordionTrigger.focus();
        }
      }

      handleKeydown(event, index) {
        const keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
        if (!keys.includes(event.key)) return;

        event.preventDefault();
        let nextIndex = index;

        if (event.key === 'ArrowLeft') {
          nextIndex = index === 0 ? this.tabs.length - 1 : index - 1;
        } else if (event.key === 'ArrowRight') {
          nextIndex = index === this.tabs.length - 1 ? 0 : index + 1;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = this.tabs.length - 1;
        }

        this.activateTab(nextIndex);
        this.tabs[nextIndex].focus();
      }
    }

    customElements.define('tabbed-panel-component', TabbedPanelComponent);

    const refreshTabbedPanels = (event) => {
      const scope = event?.target || document;
      scope.querySelectorAll('tabbed-panel-component[data-tabbed-panel]').forEach((panel) => {
        panel.init();
      });
    };

    document.addEventListener('shopify:section:load', refreshTabbedPanels);
    document.addEventListener('shopify:block:select', refreshTabbedPanels);
  }
  } catch(e) { console.error(e); }
})();

})();
